// 各种语言的单复数规则
// @see https://unicode-org.github.io/cldr-staging/charts/latest/supplemental/language_plural_rules.html
/**
 * french
 */
var fr = function (n) {
    if (n === 0 || n === 1) {
        return 'one';
    }
    if (n >= 1e6) {
        return 'many';
    }
    return 'other';
};
/**
 * polish
 */
var pl = function (n) {
    if (n === 1) {
        return 'one';
    }
    if (!Number.isInteger(n)) {
        return 'other';
    }
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) {
        return 'few';
    }
    if (![2, 3, 4].includes(n % 10) || [12, 13, 14].includes(n % 100)) {
        return 'many';
    }
    return 'other';
};
/**
 * english, default
 */
var en = function (n) {
    if (n === 0) {
        return 'zero';
    }
    if (n === 1) {
        return 'one';
    }
    return 'other';
};
var handler = { fr: fr, pl: pl, en: en };
export default handler;
//# sourceMappingURL=plural-rules.js.map